import React, { useState } from 'react';
import ImageSlider from './image-slider';
import {
  TickOneIcon,
  OneFacebookIcon,
  OneInstagramIcon,
  OneTikTokIcon,
} from '../../atoms/icons';
import { redirectToProductDetails } from '../../../utils';
import NoImage from '../../../assets/images/no-image.png';
import defaultAvatar from '../../../assets/images/default-avatar.jpg';
import VideoSlider from './video-slider';

export const TemplateSix = ({
  expertiseData,
  preferredBrands,
  preferredProducts,
  redirectToBuyerPortal,
  redirectToShopPortal,
  cardDetails,
  schedulerEnabled,
}) => {
  const { seller, storefront } = cardDetails?.current?.config;
  const LogoUrl =
    storefront?.general?.longLogoImage?.url ||
    storefront?.general?.logoImage?.url ||
    null;

  const [isExpanded, setIsExpanded] = useState(false);
  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };
  return (
    <>
      <section className="six-warpper">
        <div className="main-wrp">
          <div className="left-block">
            <div>
              <div className="mobile-bg">
                <section className="flex justify-between items-center gap-6 six-head-sec  px-4 py-2.5 md:py-0">
                  {LogoUrl ? (
                    <div className="logo-box max-w-56">
                      <img src={LogoUrl} alt="logo" />
                    </div>
                  ) : (
                    <h2 className="logo-text capitalize text-sixPrimary break-words">
                      {storefront?.general?.name}
                    </h2>
                  )}
                </section>

                <div className="flex gap-5 items-center justify-between mobile-icon md:mt-10">
                  <div className="flex gap-4 flex-col  items-center mt-5 icons">
                    {seller?.profile?.facebookUrl && (
                      <a
                        href={seller?.profile?.facebookUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cursor-pointer"
                      >
                        <OneFacebookIcon
                          fillColor="white"
                          className="text-sixPrimary"
                        />
                      </a>
                    )}
                    {seller?.profile?.instagramUrl && (
                      <a
                        href={seller?.profile?.instagramUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cursor-pointer"
                      >
                        <OneInstagramIcon
                          fillColor="white"
                          className="text-sixPrimary"
                        />
                      </a>
                    )}
                    {seller?.profile?.tiktokUrl && (
                      <a
                        href={seller?.profile?.tiktokUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cursor-pointer"
                      >
                        <OneTikTokIcon
                          fillColor="white"
                          className="text-sixPrimary"
                        />
                      </a>
                    )}
                  </div>
                  <div className="image-box">
                    <img
                      src={
                        seller?.profile?.avatar?.mediumUrl ||
                        seller?.profile?.avatar?.url ||
                        defaultAvatar
                      }
                      alt="icon"
                      className="profilebg"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = defaultAvatar;
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="block md:hidden p-5">
                <div>
                  <h2 className="text-black-main font-bold md:text-6xl text-4xl font-tempOne capitalize">
                    {seller?.profile?.title}
                  </h2>

                  <div className="long-text">
                    <div
                      className={
                        isExpanded
                          ? 'full-text'
                          : seller?.profile?.about?.length > 600
                          ? 'clamped-text'
                          : ''
                      }
                    >
                      <p
                        className="font-bold lg:text-xl mt-5 font-tempOne after:border-twoPrimary text-[#585858] md:max-w-72"
                        dangerouslySetInnerHTML={{
                          __html: seller?.profile?.about,
                        }}
                      />
                    </div>
                    {seller?.profile?.about?.length > 600 && (
                      <div className="text-right">
                        <button
                          className="text-sixPrimary read-text"
                          onClick={toggleReadMore}
                        >
                          {isExpanded ? 'Read Less' : 'Read More'}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="box-wrp">
                <button
                  className="text-white-main md:text-xl text-base mt-10 md:w-auto w-full px-10 py-4 rounded-SixCustom bg-sixPrimary border"
                  onClick={() =>
                    redirectToShopPortal(storefront?.general?.shopUrl)
                  }
                >
                  Shop the store
                </button>
              </div>
            </div>
          </div>
          <div className="right-block">
            <section className="md:flex justify-end items-center gap-6 six-head-sec  px-4  hidden"></section>
            <div className="md:flex md:flex-col flex-col-reverse">
              <div className="xl:flex gap-5 justify-between">
                <div className="hidden md:block set-w-six">
                  <h2 className="text-fourPrimary font-bold lg:text-5xl text-3xl font-tempOne capitalize ">
                    {seller?.profile?.title}
                  </h2>

                  <div className="long-text">
                    <div
                      className={
                        isExpanded
                          ? 'full-text'
                          : seller?.profile?.about?.length > 600
                          ? 'clamped-text'
                          : ''
                      }
                    >
                      <p
                        className="font-bold lg:text-xl mt-5 font-tempOne after:border-twoPrimary text-[#585858]"
                        dangerouslySetInnerHTML={{
                          __html: seller?.profile?.about,
                        }}
                      />
                    </div>
                    {seller?.profile?.about?.length > 600 && (
                      <div className="text-right">
                        <button
                          className="text-sixPrimary read-text"
                          onClick={toggleReadMore}
                        >
                          {isExpanded ? 'Read Less' : 'Read More'}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
                <div className="mt-10">
                  {preferredProducts?.length ? (
                    <div
                      className={
                        preferredProducts?.length === 0
                          ? 'visibility-hidden'
                          : 'visibility-auto'
                      }
                    >
                      <h2 className="text-black-main font-semibold text-2xl font-tempOne  mb-5 md:mt-0 mt-4  text-center">
                        My Favorite Products
                      </h2>
                      <div className="grid grid-cols-2 md:gap-4 gap-2 flex-wrap justify-center">
                        {preferredProducts
                          ?.slice(0, 4)
                          .map((product, index) => (
                            <div
                              key={index}
                              className="image-wrp cursor-pointer"
                              onClick={() =>
                                redirectToProductDetails(
                                  storefront?.general?.shopUrl +
                                    '/products/' +
                                    product?.slug
                                )
                              }
                            >
                              <img
                                src={
                                  product?.primaryImage?.mediumUrl ||
                                  product?.primaryImage?.thumbUrl ||
                                  NoImage
                                }
                                alt={`Product ${index + 1}`}
                              />
                            </div>
                          ))}
                      </div>
                    </div>
                  ) : preferredBrands?.length ? (
                    <div
                      className={
                        preferredBrands?.length === 0
                          ? 'visibility-hidden'
                          : 'visibility-auto'
                      }
                    >
                      <h2 className="text-black-main font-semibold text-2xl font-tempOne  mb-5 md:mt-0 mt-4  text-center">
                        My Favorite Brands
                      </h2>
                      <div className="grid grid-cols-2 md:gap-4 gap-2 flex-wrap justify-center">
                        {preferredBrands?.slice(0, 4).map((product, index) => (
                          <div
                            key={index}
                            className="image-wrp cursor-pointer"
                            onClick={() =>
                              redirectToProductDetails(
                                storefront?.general?.shopUrl +
                                  '/brands/' +
                                  product?.slug
                              )
                            }
                          >
                            <img
                              src={
                                product?.coverImage?.mediumUrl ||
                                product?.coverImage?.thumbUrl ||
                                NoImage
                              }
                              alt={`Product ${index + 1}`}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div>
                {expertiseData?.length ? (
                  <div
                    className={
                      expertiseData?.length === 0
                        ? 'visibility-hidden'
                        : 'visibility-auto'
                    }
                  >
                    <h2 className=" font-semibold text-2xl font-tempOne mt-10 mb-5">
                      Expertise
                    </h2>
                    <ul>
                      {expertiseData?.map((item, index) => (
                        <li key={index} className="flex tick-top mb-2">
                          <TickOneIcon className="text-sixPrimary" />
                          <span className="ml-2.5 font-normal text-base">
                            {item?.name}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  <div
                    className={
                      seller?.profile?.expertise
                        ? 'visibility-auto'
                        : 'visibility-hidden'
                    }
                  >
                    <h2 className=" font-semibold text-2xl font-tempOne mt-10 mb-5">
                      Expertise
                    </h2>
                    <p
                      className=" mt-5 font-tempOne after:border-twoPrimary"
                      dangerouslySetInnerHTML={{
                        __html: seller?.profile?.expertise,
                      }}
                    />
                  </div>
                )}
                {schedulerEnabled && (
                  <div className="text-center mt-6">
                    <button
                      className="text-white-main md:text-xl text-base md:w-auto w-full px-10 py-4 rounded-SixCustom bg-sixPrimary border"
                      onClick={() => redirectToBuyerPortal()}
                    >
                      Book an appointment
                    </button>
                  </div>
                )}
              </div>
              <div>
                {seller?.profile?.galleryImages?.length ? (
                  <section>
                    <h2 className="text-black-main font-semibold text-2xl font-tempOne md:mt-10 mt-4 mb-5 md:text-left text-center">
                      Salon Gallery
                    </h2>
                    <div className="siximage-slider">
                      <ImageSlider images={seller?.profile?.galleryImages} />
                    </div>
                  </section>
                ) : (
                  <></>
                )}
                {seller?.profile?.galleryVideoLinks?.length ? (
                  <>
                    <section>
                      <h2 className="text-black-main font-semibold text-2xl font-tempOne md:mt-7 mt-18 mb-5 md:text-left text-center">
                        Salon Videos
                      </h2>
                      <div className="siximage-slider">
                        <VideoSlider
                          videos={seller?.profile?.galleryVideoLinks}
                        />
                      </div>
                    </section>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
